<div class="flex justify-center h-full">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Forgot Email</h2>
    <div class="text-sm">Please enter your mobile phone number.</div>
    <form id="forgotEmailForm" #forgotEmailForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">
      <div>
          <mat-form-field class="w-full">
            <mat-label>Cell Phone</mat-label>
            <mat-input-tel name="CellPhone" id="CellPhone" cellPhone [(ngModel)]="cellPhone" #CellPhone="ngModel" required >
            </mat-input-tel>
            <mat-error>Please enter a valid phone number</mat-error>
          </mat-form-field>
        </div>
        <div class="text-sm my-2">
          By clicking submit, I consent to receiving a one-time text message from Tricon to verify my identify.
          If your phone number is linked to multiple email addresses, then one text message per email address is sent.
          Message and data rates may apply.
        </div>
      <button mat-flat-button color="primary" type="submit" class="my-2" [disabled]="!forgotEmailForm.form.valid">SUBMIT</button>
    </form>
  </div>
</div>
